import auditStatus from '@/constants/auditStatus'

export const getIdPass = (poiAuditStatus, ibtPoiAuditStatus, id3Pass = false) =>
  poiAuditStatus === auditStatus.completed ||
  // For existing user who have advanced but no general audit record
  (poiAuditStatus === auditStatus.init && ibtPoiAuditStatus === auditStatus.completed) ||
  id3Pass

export const getPoaPass = (poaAuditStatus, ibtPoaAuditStatus) =>
  poaAuditStatus === auditStatus.completed ||
  // For existing user who have advanced but no general audit record
  (poaAuditStatus === auditStatus.init && ibtPoaAuditStatus === auditStatus.completed)
